export enum TokenValidationState
{
    none,
    processing,
    invalid,
    valid,
    error
}
